import { handleActions } from 'redux-actions';
import { AppState } from '../types/store';
import {
  watchTopicSuccess,
  unwatchTopicSuccess,
  suppressTopicSuccess,
} from '@wix/da-shared-react/pkg/redux/topic/actions';
import { PapiTopic } from '@wix/da-papi-types';

type StateSlice = NonNullable<AppState['currentPageData']>;

const isCurrentTopicAction = (state: StateSlice, action: any) =>
  state.thisNeco && state.thisNeco.itemId === action.payload.params.necoid;

const updateUserTopicSubscriptionIfCurrentTopic = (
  state: StateSlice,
  action: any,
  userTopicSubscription: PapiTopic['userTopicSubscription']
) =>
  isCurrentTopicAction(state, action)
    ? {
        ...state,
        thisNeco: {
          ...state.thisNeco!,
          userTopicSubscription,
        },
      }
    : state;

const reducer = handleActions<StateSlice, any>(
  {
    [`${watchTopicSuccess}`]: (
      state: StateSlice,
      action: ReturnType<typeof watchTopicSuccess>
    ) => updateUserTopicSubscriptionIfCurrentTopic(state, action, 'watching'),
    [`${unwatchTopicSuccess}`]: (
      state: StateSlice,
      action: ReturnType<typeof unwatchTopicSuccess>
    ) =>
      updateUserTopicSubscriptionIfCurrentTopic(state, action, 'not-watching'),
    [`${suppressTopicSuccess}`]: (
      state: StateSlice,
      action: ReturnType<typeof suppressTopicSuccess>
    ) => updateUserTopicSubscriptionIfCurrentTopic(state, action, 'suppressed'),
  },
  {} as any
);

export default reducer;
